module.exports = __webpack_public_path__ + "img/icon6.ee6cf014.png";